import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { UrlModal } from '../shared/url.model';
import { map } from "rxjs/operators";
import { EmailValidator, Form } from "@angular/forms";

@Injectable({
  providedIn: "root",
})
export class HospitalService {
  constructor(private httpClient: HttpClient) { }

  saveHospitalToDatabase(
    name: string,
    email: string,
    password: string,
    website: string,
    phoneNo: number,
    rating: number,
    startTime: number,
    endTime: number,
    description,
    line1,
    city,
    state,
    pincode,

    token: string
  ) {
    return this.httpClient.post(
      UrlModal._URL + "/hos/reghospital",
      {
        name: name,
        email: email,
        password: password,

        phoneNo: phoneNo,
        opdTiming: {
          startTime: startTime,
          endTime: endTime,
        },
        website: website,
        description: description,
        rating: rating,
        line1: line1,
        city: city,
        state: state,
        pincode: pincode,
      },
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    );
  }
  updateHospitalToDatabase(
    name: string,
    email: string,
    website: string,
    phoneNo: number,
    rating: number,
    startTime: number,
    endTime: number,
    description,
    line1,
    city,
    state,
    pincode,

    token: string,
    id
  ) {
    return this.httpClient.put(
      UrlModal._URL + "/ad/adminupdatehos",
      {
        name: name,
        email: email,
        phoneNo: phoneNo,
        id: id,
        startTime: startTime,
        endTime: endTime,
        website: website,
        description: description,
        rating: rating,
        line1: line1,
        city: city,
        state: state,
        pincode: pincode,
      },
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    );
  }

  getHospitals(token, page) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "100");
    console.log(params);
    return this.httpClient
      .get<hospitalData>(UrlModal._URL + "/ad/gethospitals/", {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
        params: params,
      })
      .pipe(
        map((res) => {
          return {
            patData: res.data.docs,
            page: res.data.page,
            total: res.data.total,
          };
        })
      );
  }

  getHospitalFromDb(token, page) {
    let params = new HttpParams();
    params = params.append("page", page);
    params = params.append("limit", "10");
    // console.log(params);
    return this.httpClient
      .get<hospitalData>(UrlModal._URL + "/ad/gethospitals/", {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
        params: params,
      })
      .pipe(
        map((res) => {
          return {
            patData: res.data.docs,
            page: res.data.page,
            total: res.data.total,
          };
        })
      );
  }
  deleteHospital(id, token) {
    return this.httpClient.get(UrlModal._URL + "/hos/deletehospital/" + id, {
      headers: new HttpHeaders({
        authorization: "Bearer " + token,
      }),
    });
  }
  getSingleHospital(id, token) {
    return this.httpClient.get<singleHospitalData>(
      UrlModal._URL + "/hos/singlehospital/" + id,
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    );
  }
  addHospitalImages(title, image, id, token) {
    var formData = new FormData();
    const files: Array<File> = image;
    // formData.append('profileimage',image,image.name)
    // formData.append('profileimage',image,image.name)

    files.forEach((sinImg, index) => {
      formData.append("hospitalimage", sinImg, sinImg.name);
      formData.append("hospitaldesc", title[index].imagetitle);
    });
    formData.append("id", id);

    return this.httpClient.post(
      UrlModal._URL + "/hos/addhospitalimages",
      formData,
      {
        headers: new HttpHeaders({
          authorization: "Bearer " + token,
        }),
      }
    );
  }
  DeleteHosImage(token, id, index) {
    let pl = {
      id: id,
      index: index,
    };
    return this.httpClient.post(UrlModal._URL + '/hos/deleteHosImage', pl, {
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    });
  }

  addHosAsClinic(token: any, data: any) {
    return this.httpClient.post(UrlModal._URL + '/hos/adddoctor', data, {
      headers: new HttpHeaders({
        authorization: 'Bearer ' + token,
      }),
    });
  }
  addNewDoctorInHospital(token: String, data: any) {
    return this.httpClient.post(UrlModal._URL + "/hos/reghospitaldoc", data, {
      headers: new HttpHeaders({
        authorization: "Bearer " + token,
      })
    })
  }
}

export interface singleHospitalData {
  status: number;
  message: string;
  data: {
    _id: string;
    isDeleted: boolean;
    isEnabled: boolean;
    name: string;
    address: {
      address: string;
      city: string;
      pincode: number;
      state: string;
    };
    description: string;
    website: string;
    email: string;
    phoneNo: number;
    createdAt: string;
    updatedAt: string;
    __v: number;
    opdTiming: { startTime: number; endTime: number };
  };
}

export interface hospitalData {
  status: number;
  message: string;
  data: {
    docs: [
      {
        _id: string;
        isDeleted: boolean;
        isEnabled: boolean;
        name: string;
        address: {
          address: string;
          city: string;
          pincode: number;
          state: string;
        };
        description: string;
        website: string;
        email: string;
        phoneNo: number;
        createdAt: string;
        updatedAt: string;
        __v: number;
        opdTiming: { startTime: number; endTime: number };
      }
    ];
    total: number;
    limit: number;
    page: number;
    pages: number;
  };
}

/*{"status":200,"message":"getting data"
,"data":{"docs":[{"opdTiming":{"startTime":4,"endTime":4},
"address":{"address":"ADDRESS","city":"CITY","state":"STATE","pincode":4444444},"isDeleted":false,
"isEnabled":true,"_id":"5ecbcc472a273008745d5451","name":"sammy","phoneNo":7777777777,
"website":"rrrrr","email":"harry123@gmail.com","description":"dffsfsfdsssds",
"createdAt":"2020-05-25T13:46:47.514Z","updatedAt":"2020-05-25T13:46:47.514Z","__v":0},
{"opdTiming":{"startTime":4,"endTime":4},"address":{"address":"ADDRESS","city":"CITY","state":"STATE","pincode":4444444},"isDeleted":false,"isEnabled":true,"_id":"5ecbcacf2a273008745d5450","name":"sammy","phoneNo":7777777777,"website":"rrrrr","email":"harry123@gmail.com","description":"dffsfsfdsssds",
"createdAt":"2020-05-25T13:40:31.831Z","updatedAt":"2020-05-25T13:40:31.831Z","__v":0}],"total":2,"limit":10,"page":1,"pages":1}}*/
